import smartAuthAPI from '../smartbestbuys-api'
import { errorSingleHandler } from '../../middleware'
import { Document } from './types'

export const getDocumentById = errorSingleHandler<Document<any, any>>(async (id: number) => {
  return await smartAuthAPI.get(`/documents/${id}`)
})
